import { render, staticRenderFns } from "./DashboardStart.vue?vue&type=template&id=580233d7&"
import script from "./DashboardStart.vue?vue&type=script&lang=js&"
export * from "./DashboardStart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStart.vue?vue&type=style&index=0&id=580233d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports